import React from 'react';
import Service from '../Components/Service/Service';
import { useTranslation } from 'react-i18next';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const Services = () => {
  const { t } = useTranslation();

  // Services data
  const servicesData = [
    { text: t("WebContent"), title: t("WebDevelopment"), image: "./images/web1.webp" },
    { text: t("AppContent"), title: t("AppDevelopment"), image: "./images/app2.jpeg" },
    { text: t("GameContent"), title: t("GameDevelopment"), image: "./images/game.jpeg" },
    { text: t("SeoContent"), title: t("Seo"), image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfhd-70tFiWBVY7t-cmUW73GlVtDi8asDvMw&s" },
    { text: t("DigitalContent"), title: t("DigitalMarkieting"), image: "https://static.vecteezy.com/system/resources/previews/005/732/506/non_2x/man-hand-holding-smart-phone-digital-marketing-word-with-icon-business-virtual-screen-free-photo.jpg" },
    { text: t("GraphicContent"), title: t("Graphic"), image: "https://wallpapers.com/images/hd/graphic-design-1500-x-900-picture-lpuf40e9jm621ews.jpg" },
  ];

  // Group services in chunks of 3
  const groupedServices = [];
  for (let i = 0; i < servicesData.length; i += 3) {
    groupedServices.push(servicesData.slice(i, i + 3));
  }

  useGSAP(() => {
    // Context-safe animation, exactly like in Experties
    gsap.utils.toArray(".services-group").forEach((group) => {
      gsap.from(group.children, {
        y: 50,
        opacity: 0,
        scale: 0,
        duration: 1.5,
        stagger: 0.8,
        filter: "blur(10px)",
        ease: "power3.out",
        scrollTrigger: {
          trigger: group,
          start: "top center",
          toggleActions: "play none none none",
          // markers: true,  // debug ke liye
        },
      });
    });
  }, []);

  return (
    <div className='bg-[#091c30] dark:bg-gradient-to-r dark:to-teal-400 dark:from-blue-700'>
      <div className="bg-transparent relative z-10 md:px-10 px-4 py-12 font-[sans-serif]">
        <div className="max-w-5xl max-lg:max-w-3xl max-sm:max-w-sm mx-auto">
          <div className='my-5'>
            <h1 className='text-center expert xs:text-5xl xxs:text-4xl sm:text-6xl font-bold font-serif text-white mb-12 mt-5'>
              {t("OurService")}
            </h1>
          </div>

          {/* Groups of 3 services */}
          {groupedServices.map((group, idx) => (
            <div key={idx} className="services-group grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
              {group.map((service, index) => (
                <Service
                  key={index}
                  text={service.text}
                  title={service.title}
                  image={service.image}
                />
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Services;
